export default function Logo({ className = "h-11 md:h-14 w-auto" }) {
  return (
    <img
      src="/logo.png"
      alt="B&S Global Ventures"
      className={`object-contain object-left shrink-0 ${className}`}
      decoding="async"
    />
  );
}
